import React from 'react';
import PrinterCard from './PrinterCard';

const PrinterGrid = ({
  printers,
  expandedPrinterId,
  connectingPrinter,
  printerDetails,
  LOCATIONS,
  onPrinterClick,
  onPrinterDetailChange,
  onTestPrint,
  onSavePrinter
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 p-4">
      {printers.map((printer) => (
        <PrinterCard
          key={printer.innerMacAddress}
          printer={printer}
          expandedPrinterId={expandedPrinterId}
          connectingPrinter={connectingPrinter}
          printerDetails={printerDetails}
          LOCATIONS={LOCATIONS}
          onPrinterClick={onPrinterClick}
          onPrinterDetailChange={onPrinterDetailChange}
          onTestPrint={onTestPrint}
          onSavePrinter={onSavePrinter}
        />
      ))}
    </div>
  );
};

export default PrinterGrid; 